
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetokolhapurcab() {



    const cardData =
    {
        keyword: ' Pune to Kolhapur cab',
        heading: 'S9 Travels:  Pune to Kolhapur cab',
        headingDescription: 'S9 Travels offers reliable and comfortable Pune to Kolhapur cab services, ensuring a smooth and hassle-free journey. The distance from Pune to Kolhapur is approximately 235 km, with a travel time of around 4 to 5 hours by road. Our well-maintained cabs, professional drivers, and excellent customer service guarantee a safe and enjoyable ride. Whether you are traveling for business, leisure, or a family trip, S9 Travels provides a seamless and stress-free travel experience.',

        top: 'Top Places to Visit in Kolhapur with S9 Travels',

"topPlaces": [
    {
      "title": "Mahalaxmi Temple",
      "description": "The Mahalaxmi Temple, dedicated to Goddess Mahalaxmi, is one of the most revered pilgrimage sites in India and a must-visit in Kolhapur."
    },
    {
      "title": "Rankala Lake",
      "description": "A serene lake in Kolhapur, Rankala Lake is perfect for evening strolls, boating, and enjoying scenic sunset views."
    },
    {
      "title": "Panhala Fort",
      "description": "Panhala Fort is a historic fort near Kolhapur that offers breathtaking views, rich Maratha history, and architectural brilliance."
    },
    {
      "title": "Jyotiba Temple",
      "description": "Located on a hill, the Jyotiba Temple is dedicated to Lord Jyotiba and offers a peaceful spiritual experience along with scenic surroundings."
    },
    {
      "title": "New Palace Museum",
      "description": "A grand palace showcasing the rich history and artifacts of the Kolhapur royal family, now converted into a museum."
    },
    {
      "title": "Shalini Palace",
      "description": "A beautiful heritage palace on the banks of Rankala Lake, known for its stunning architecture and royal legacy."
    },
    {
      "title": "Khasbag Wrestling Stadium",
      "description": "A historic wrestling arena, Khasbag Maidan is one of the oldest wrestling stadiums in India, showcasing Kolhapur’s strong wrestling culture."
    },
    {
      "title": "Bhavani Mandap",
      "description": "A historic palace that once served as a court hall for the Kolhapur rulers, now a popular tourist and shopping destination."
    },
    {
      "title": "Dajipur Wildlife Sanctuary",
      "description": "A perfect getaway for wildlife lovers, this sanctuary is home to Indian bison, deer, and various species of birds."
    },
    {
      "title": "Siddhagiri Gramjivan Museum",
      "description": "An open-air museum depicting traditional village life in Maharashtra with life-size statues and cultural exhibits."
    }
],

"services": [
    {
      "name": "Pune to Kolhapur Cab Service",
      "description": "Book a reliable and comfortable cab from Pune to Kolhapur. Whether it's for a family trip or a pilgrimage, our service ensures a smooth and enjoyable journey."
    },
    {
      "name": "Book Pune to Kolhapur Taxi",
      "description": "Booking a taxi from Pune to Kolhapur is easy with us. Choose from a range of vehicles to suit your needs and enjoy a hassle-free ride to this historical city."
    },
    {
      "name": "Affordable Pune to Kolhapur Cab",
      "description": "We offer affordable cab services for your Pune to Kolhapur trip. Enjoy a comfortable and economical ride without compromising on quality."
    },
    {
      "name": "Private Taxi for Kolhapur from Pune",
      "description": "Looking for a private ride to Kolhapur from Pune? Our private taxis offer a personalized, comfortable experience for you, your family, or friends."
    },
    {
      "name": "Pune to Kolhapur One-Way or Round Trip",
      "description": "Choose from one-way or round-trip options for your Pune to Kolhapur journey. Whether it's a single trip or a return, we provide flexible taxi services to fit your schedule."
    },
    {
      "name": "Luxury Cab from Pune to Kolhapur",
      "description": "Travel in luxury to Kolhapur with our premium cabs. Enjoy plush seating, excellent amenities, and a smooth ride, perfect for a special occasion or indulgent trip."
    },
    {
      "name": "Comfortable Taxi Ride for Kolhapur",
      "description": "Experience a comfortable and relaxing taxi ride from Pune to Kolhapur. Our well-maintained vehicles and professional drivers ensure a smooth journey."
    },
    {
      "name": "Kolhapur Sightseeing by Taxi from Pune",
      "description": "Explore the historic city of Kolhapur with a private taxi for sightseeing. Visit the famous temples, palaces, and markets while enjoying a custom tour."
    },
    {
      "name": "Group Travel to Kolhapur from Pune",
      "description": "Traveling with a group? Our spacious taxis are perfect for group travel to Kolhapur. Everyone can enjoy a comfortable ride together, with ample space for luggage."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Cab Service", "Book Pune to Kolhapur Taxi"],
    ["Affordable Pune to Kolhapur Cab", "Private Taxi for Kolhapur from Pune"],
    ["Pune to Kolhapur One-Way or Round Trip", "Luxury Cab from Pune to Kolhapur"],
    ["Comfortable Taxi Ride for Kolhapur", "Kolhapur Sightseeing by Taxi from Pune"],
    ["Group Travel to Kolhapur from Pune", "Pune to Kolhapur One-Way or Round Trip"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure your trip from Pune to Kolhapur is punctual and hassle-free. Our drivers are always on time, ensuring a smooth pickup from your location in Pune and a timely arrival in Kolhapur, so you can relax and enjoy the journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is perfect for your Pune to Kolhapur journey. With comfortable seating, air conditioning, and plenty of space for luggage, you’ll enjoy a relaxing and comfortable ride. Whether you’re traveling solo or with family and friends, our vehicles ensure a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, professional, and familiar with the best routes between Pune and Kolhapur. They are courteous, knowledgeable, and focused on ensuring your safety and comfort, making your trip enjoyable and hassle-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Kolhapur ride. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, so you can plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey throughout your trip from Pune to Kolhapur."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7 for your Pune to Kolhapur ride. Whether it’s an early morning departure or a late-night trip, we ensure that your ride is ready when you need it. Our customer service team is always available to assist you with any booking needs."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Kolhapur cab is easy with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for personalized assistance in securing your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Pune to Kolhapur trip. Whether you need to make additional stops or have specific preferences for your journey, we tailor the trip to meet your needs, ensuring a personalized and enjoyable experience."
  }
]









    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Kolhapur with S9 Travels?',
            answer: 'Booking a cab for your Pune to Kolhapur trip is easy! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Kolhapur travel?',
            answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that suits your needs for a comfortable and smooth journey to Kolhapur.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Kolhapur route?',
            answer: 'Yes, our drivers are experienced and familiar with the best routes from Pune to Kolhapur. They ensure a safe, smooth, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Kolhapur?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and secure online payments via our mobile app, making it easy and convenient to pay for your ride.'
          },
          {
            question: 'Can I book a round trip from Pune to Kolhapur?',
            answer: 'Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll ensure your ride back from Kolhapur to Pune is as comfortable and timely as your trip there.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges for detours or waiting time will be clearly communicated to you in advance, ensuring full transparency in pricing.'
          },
          {
            question: 'Can I make additional stops on the way to Kolhapur?',
            answer: 'Yes, you can request additional stops along the way. Please inform us during the booking process, and we’ll accommodate your requests for detours or stops during your journey.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Kolhapur trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Kolhapur?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Kolhapur, ensuring a professional, comfortable, and timely service for your business travel needs.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Kolhapur cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Pune to Kolhapur.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Amit Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels from Pune to Kolhapur, and the experience was fantastic. The driver was on time, the vehicle was clean and comfortable, and the journey was smooth. I highly recommend S9 Travels for anyone traveling to Kolhapur!”'
        },
        {
          name: 'Mrs. Shilpa Reddy',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our trip from Pune to Kolhapur so easy and stress-free. The vehicle was spacious and well-maintained, and the driver was professional and friendly. I’ll definitely choose S9 Travels for future trips.”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Kolhapur Cab",
        "description": "Book an affordable and reliable Pune to Kolhapur cab service with S9 Travels. Enjoy a smooth, comfortable, and safe journey with our professional drivers. Whether you're planning a one-way trip or a round-trip, our well-maintained vehicles ensure a hassle-free and pleasant travel experience.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "2789"
        }
      };
      
    
      
      
      


    return (
        <div>
          <Helmet>
        <title>Pune to Kolhapur Cab | Comfortable & Affordable Taxi Service | S9 Travels</title>
        <meta 
          name="description" 
          content="Book your Pune to Kolhapur cab with S9 Travels. Travel comfortably and safely with professional drivers and well-maintained vehicles. Choose from one-way or round-trip options for a smooth, hassle-free journey to Kolhapur." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/99.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokolhapurcab;